// 「全 N 件を選択」バナー（発注照合テーブルの実装を切り出した共通部品）。
// 表示条件（totalPages > 1 && ページ全選択）は呼び出し側に残す
export function SelectAllResultsBanner({
  entityLabel,
  totalCount,
  pageCount,
  selectionMode,
  selectAllPending = false,
  onSelectAllResults,
  onClearSelection,
  testIdPrefix,
}: {
  entityLabel: string
  totalCount: number
  pageCount: number
  selectionMode: 'ids' | 'all'
  selectAllPending?: boolean
  onSelectAllResults: () => void
  onClearSelection: () => void
  testIdPrefix: string
}) {
  return (
    <div className="flex min-h-10 items-center justify-center gap-2 border-b border-primary/15 bg-accent/60 px-4 py-2 text-sm">
      {selectionMode === 'all' ? (
        <>
          <span className="text-muted-foreground">
            全 {totalCount.toLocaleString()} 件の{entityLabel}が選択されています。
          </span>
          <button
            type="button"
            onClick={onClearSelection}
            className="font-medium text-primary hover:underline"
            data-testid={`${testIdPrefix}-clear-selection`}
          >
            選択を解除
          </button>
        </>
      ) : (
        <>
          <span className="text-muted-foreground">このページの {pageCount} 件がすべて選択されています。</span>
          <button
            type="button"
            disabled={selectAllPending}
            onClick={onSelectAllResults}
            className="font-medium text-primary hover:underline disabled:opacity-50"
            data-testid={`${testIdPrefix}-select-all-results`}
          >
            {selectAllPending ? '選択中...' : `全 ${totalCount.toLocaleString()} 件の${entityLabel}を選択`}
          </button>
        </>
      )}
    </div>
  )
}
